module.exports = __webpack_public_path__ + "static/dwarf_golden_male_2_SCAG-3f0be82755b3c45ce18121c81959681f.webp";